module.exports = __webpack_public_path__ + "img/BET_example_en.c4053904.png";